import get from 'lodash/get';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';

import { contextPath } from '@atlassian/help-center-common-util/history';
import { reportError } from '@atlassian/help-center-common-util/sentry';

const GATEWAY_APOLLO_CLIENT_ID = 'GATEWAY';
const NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';

const retryLink = new RetryLink({
    delay: {
        initial: 5000,
        max: 5000,
    },
    attempts: {
        max: 2,

        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        retryIf: (networkError) => networkError && !networkError.statusCode,
    },
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors)
        if (Array.isArray(graphQLErrors)) {
            graphQLErrors.forEach(({ message, locations, path }) => {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
                reportError(new Error(`Apollo GraphQL error: ${message} - ${JSON.stringify({ locations, path })}`), {
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    message: `Apollo GraphQL error: ${message}`,
                });
            });
        }

    if (networkError) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const occurredNetworkErrorsBefore: number = get(operation.getContext(), [NETWORK_ERRORS_COUNTER_KEY], 0);
        if (occurredNetworkErrorsBefore > 5) {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            reportError(`Apollo GraphQL Network error: ${networkError}, attempt ${occurredNetworkErrorsBefore + 1}`);
        }
        operation.setContext({
            [NETWORK_ERRORS_COUNTER_KEY]: occurredNetworkErrorsBefore + 1,
        });
    }
});

const cache = new InMemoryCache();

export const clientCreator = () => {
    const uri = `${contextPath}/gateway/api/graphql`;
    const link = ApolloLink.from([
        retryLink,
        errorLink,
        new HttpLink({
            uri,
            credentials: 'same-origin',
        }),
    ]);

    return new ApolloClient({
        cache,
        link,
        name: GATEWAY_APOLLO_CLIENT_ID,
    });
};
